import {
  CUSTOM_OK,
  PALETTE_BLUE_1200,
  PALETTE_ERROR_MAIN,
  PALETTE_GRAY_600,
  PALETTE_MAGENTA_1200,
  PALETTE_RED_1400,
} from 'utils/colours';

export type EventData = {
  time: number;
  event: EventEnum;
  adId?: string;
  spotTime?: number;
  message?: string;
};

export enum EventEnum {
  Play = 'Play',
  Ad = 'Ad',
  Filler = 'Filler',
  Skip = 'Skip',
  Error = 'Error',
  Sync = 'Sync',
}

export const eventColours = {
  Play: CUSTOM_OK,
  Ad: PALETTE_MAGENTA_1200,
  Filler: PALETTE_GRAY_600,
  Skip: PALETTE_RED_1400,
  Error: PALETTE_ERROR_MAIN,
  Sync: PALETTE_BLUE_1200,
};
